import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Cash } from 'react-bootstrap-icons';
import '../styles/tables.css';
import CrearPagoModal from './componentes/crearPagoModal';
import TablaPagos from './componentes/tablaPagos';

function AdminPagosHe() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className='mx-2 mt-3'>
      <div className='d-flex flex-column flex-md-row align-items-center justify-content-between'>
        <p className='mb-2 mb-md-0 text-center'>
          Registra tus egresos y mantiene una contabilidad precisa de tu negocio.
        </p>
        <div className='d-flex mt-2 mt-md-0'>
          <Button variant='danger' onClick={handleShow}>
            <Cash /> Nuevo Pago
          </Button>
        </div>
      </div>
      {/* Modal para crear pago */}
      <CrearPagoModal show={show} handleClose={handleClose} />
      {/* Tabla Pagos */}
      <div className='mt-4'>
      <TablaPagos />
      </div>
    </div>

  );
}

export default AdminPagosHe;
